import { IAvailableRequest } from "../types/types";
import { callApi } from "./api.service";

export const GetAvailableNow = async (data: IAvailableRequest) => {
  const endpoints = "/api/public/available-now";
  return await callApi(endpoints, "POST", false, undefined, data);
};

export const GetAvailableNowWithToken = async (
  data: IAvailableRequest,
  getToken: () => Promise<string | null>
) => {
  const endpoints = "/api/available-now";
  return await callApi(endpoints, "POST", true, getToken, data);
};
